/* 系统管理->设备管理 */
<template>
  <div class="sbgl">
    <div class="u-form">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          设备管理
        </h4>
      </template>
      <car-form @submit="submit" :showformitem="formitem">
        <template>
          <el-button type="success" size="small" @click="add">添加</el-button>
        </template>
      </car-form>
    </div>

    <hy-data-table
      v-model="loading"
      height="94%"
      ref="dataTable"
      @find-page="findPage"
      @open-device="openDevice"
      @close-device="closeDevice"
      @detail-handle="detailHandle"
      @map-path="mapPath"
      @del="del"
      is-all-handle
      :data="dataTable.list"
      :columns="dataTable.columns"
      :extend-buttons="dataTable.buttons"
      :show-batch-delete="true"
      :show-operation="true"
      size="medium"
      :paging="dataTable.paging"
      :extend-but-widht="130"
    ></hy-data-table>
  </div>
</template>

<script>
import carForm from '@/components/form/carForm.vue';
import hyDataTable from '@/components/HyDataTable.vue';
import { mapState } from 'vuex';
import { requireJson, getdict } from '@/commons/util.js';
export default {
  components: {
    carForm,
    hyDataTable
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh
    })
  },
  data() {
    return {
      saveAddTemplate: {},

      form: {},
      height: '',
      formitem: [
        'deviceName', //设备名称
        'tollgateID', //卡口
        'deviceType', //设备类型
        'inOutFlag' //出入口标识
      ],
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      detailList: [
        '设备编号',
        '设备名称*',
        '设备位置*',
        '设备类型*',
        '卡口选择',
        '经度*',
        '纬度*',
        '出入口标识',
        '设备状态',
        '设备IP*',
        '设备端口*',
        '设备厂商',
        '厂商联系人',
        '厂商联系电话',
        '设备登录帐号',
        '设备登录密码',
        '创建时间',
        '创建人',
        '修改时间',
        '修改人',
        '设备生产日期',
        '设备维保到期',
        '厂家设备编号',
        '设备图片',
        '备注'
      ], //详情修改显示的项目
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: 'tollgateID1', label: '卡口编号', minWidth: 150 },
          { prop: 'deviceID', label: '设备编号', minWidth: 80 },
          { prop: 'deviceName', label: '设备名称', minWidth: 100 },
          { prop: 'deviceType', label: '设备类型', minWidth: 100 },
          { prop: 'place', label: '设备位置', minWidth: 150 },
          { prop: 'longitude', label: '经度', minWidth: 60 },
          { prop: 'latitude', label: '纬度', minWidth: 60 },
          { prop: 'inOutFlag', label: '出入口', minWidth: 80 },
          { prop: 'status', label: '设备状态', minWidth: 60 },

        ],
        buttons: [
          {
            label: "开闸",
            click: "open-device",
            perms: 100102,
            icon: 'fa fa-picture-o',
            type:"success",
          },
          {
            label: "关闸",
            click: "close-device",
            perms: 100102,
            icon: 'fa fa-picture-o',
            type:"info",
          },
          {
            label: '详情',
            click: 'detail-handle',
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: 'primary'
          },
          /* {
            label: "修改",
            click: "map-path",
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: "info"
          }, */
          {
            label: '删除',
            click: 'del',
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: 'error'
          }
        ],
        paging: {
          pageIndex: 1, // 表格分页信息
          pageRow: 10,
          total: 0
        }
      }
    };
  },
  methods: {
    stateFormat(row, column) {
            if (row.state === true) {
              return '正确'
            } else  {
              return '错误'
            }
          },

    submit(form) {
      console.log('提交表单', form);
      this.form.deviceName = form.deviceName;
      this.form.deviceType = form.deviceType;
      this.form.inOutFlag = form.inOutFlag;
      if (form.tollgateID) {
        this.form.tollgateId = form.tollgateID;
      }else{
        delete this.form.tollgateId;
      }
      this.pageIndex = 1;
      this.dataTable.paging.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      //console.log("findPage", res1);
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    //添加
    add() {
      const data = this.saveAddTemplate;

      this.$store.commit('boxDetail', {
        data: data,
        title: '新增',
        api: 'POST_deviceAdd',
        uploadImgApi: this.$apis.POST_deviceImg,
        sort: this.detailList
      });
    },
    //详情
    detailHandle(res) {
      const data = res.row;
      console.log('aaaaaaa', data);
      this.$http
        .GET_deviceInfo({ paramsID: '/' + data.deviceID })
        .then((response) => {
          console.log('详情接口结果', response);
          this.$store.commit('boxDetail', {
            data: response.data,
            title: '详情',
            api: 'POST_deviceUpdate',
            uploadImgApi: this.$apis.POST_deviceImg,
            sort: this.detailList
          });
        });
    },
    mapPath(res1) {
      console.log('mapPath', res1);
    },
    openDevice(res1) {
      console.log('openDevice', res1);
      if(res1.row.deviceType == "行人闸机" ){
        let formData = new FormData()
        formData.append("id", res1.row.deviceID)
        this.$http.POST_openFacedevice(formData)
          .then((res) => {
            if(res.code == '00000'){
              this.$message.success(res.msg)
            }else{
              this.$message.error(res.msg)
            }
          });
      }else{
        this.$http.GET_vehicleGate({ paramsID: '/OpenGate/' + res1.row.deviceID })
          .then((res) => {
            if(res.code == '00000'){
              this.$message.success(res.msg)
            }else{
              this.$message.error(res.msg)
            }
          });
      }
    },
    closeDevice(res1) {
      if(res1.row.deviceType == "车辆闸机" ){
        this.$http.GET_vehicleGate({ paramsID: '/CloseGate/' + res1.row.deviceID })
          .then((res) => {
            if(res.code == '00000'){
              this.$message.success(res.msg)
            }else{
              this.$message.error(res.msg)
            }
          });
      }else{
        this.$message.success("人脸关闸成功!")
      }
    },
    del(res1) {
      console.log('del', res1);
      const data = res1.row;
      this.$confirm('确定要删除吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$http
                .GET_deviceDel({ paramsID: '/' + data.deviceID })
                .then((response) => {
                  this.$message.success('删除成功');
                  if (this.dataTable.list.data.length === 1)
                    this.pageIndex = this.pageIndex - 1;
                  this.getData();
                });
            }).catch(() => {});

    },
    //数据列表
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      let arr = [];
      this.$http
        .POST_deviceList(this.form)
        .then((response) => {
          console.log('列表结果', response);
          this.dataTable.paging.total = response.total;
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].tollgateID1 = response.data[i].tollgateID;
              const result = this.$myPlug.sortName2cn(response.data[i]);
              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: []
          };
          this.$set(this.dataTable.list, 'data', arr);
          this.saveAddTemplate = JSON.parse(
            JSON.stringify(this.dataTable.list.data[0])
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //列表字典转换处理
    dictionaryChage(val, option) {
      let data = '';
      for (let item of option) {
        if (item.code == val) {
          data = item.name;
          break;
        } else {
          data = val;
        }
      }
      return data;
    }
  },
  mounted() {
    //this.getData()
  },
  created() {},
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/xtgl/sbgl.vue